var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAntlogyWsGridIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    zoomAndPan: "magnify",
    viewBox: "0 0 600 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "52216b4b99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 115.734375 297 L 570.273438 297 L 570.273438 353.265625 L 115.734375 353.265625 Z M 115.734375 297 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb42b84c97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 138.234375 297 L 547.652344 297 C 553.617188 297 559.339844 299.367188 563.5625 303.589844 C 567.78125 307.808594 570.152344 313.53125 570.152344 319.5 L 570.152344 330.765625 C 570.152344 336.734375 567.78125 342.457031 563.5625 346.675781 C 559.339844 350.894531 553.617188 353.265625 547.652344 353.265625 L 138.234375 353.265625 C 132.269531 353.265625 126.546875 350.894531 122.328125 346.675781 C 118.105469 342.457031 115.734375 336.734375 115.734375 330.765625 L 115.734375 319.5 C 115.734375 313.53125 118.105469 307.808594 122.328125 303.589844 C 126.546875 299.367188 132.269531 297 138.234375 297 Z M 138.234375 297 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b26680e936"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.734375 0 L 455.238281 0 L 455.238281 56.265625 L 0.734375 56.265625 Z M 0.734375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6fb0cdec21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.234375 0 L 432.652344 0 C 438.617188 0 444.339844 2.367188 448.5625 6.589844 C 452.78125 10.808594 455.152344 16.53125 455.152344 22.5 L 455.152344 33.765625 C 455.152344 39.734375 452.78125 45.457031 448.5625 49.675781 C 444.339844 53.894531 438.617188 56.265625 432.652344 56.265625 L 23.234375 56.265625 C 17.269531 56.265625 11.546875 53.894531 7.328125 49.675781 C 3.105469 45.457031 0.734375 39.734375 0.734375 33.765625 L 0.734375 22.5 C 0.734375 16.53125 3.105469 10.808594 7.328125 6.589844 C 11.546875 2.367188 17.269531 0 23.234375 0 Z M 23.234375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "93c0675de1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 456,
    y: 0,
    height: 57
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ff49f0edf4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.777344 21.734375 L 86.042969 21.734375 L 86.042969 353.40625 L 29.777344 353.40625 Z M 29.777344 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "72204f70f1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.277344 21.734375 L 63.542969 21.734375 C 69.511719 21.734375 75.234375 24.105469 79.453125 28.324219 C 83.675781 32.542969 86.042969 38.265625 86.042969 44.234375 L 86.042969 330.765625 C 86.042969 336.734375 83.675781 342.457031 79.453125 346.675781 C 75.234375 350.894531 69.511719 353.265625 63.542969 353.265625 L 52.277344 353.265625 C 46.308594 353.265625 40.585938 350.894531 36.367188 346.675781 C 32.148438 342.457031 29.777344 336.734375 29.777344 330.765625 L 29.777344 44.234375 C 29.777344 38.265625 32.148438 32.542969 36.367188 28.324219 C 40.585938 24.105469 46.308594 21.734375 52.277344 21.734375 Z M 52.277344 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3d94259f89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.777344 0.734375 L 57.042969 0.734375 L 57.042969 332.28125 L 0.777344 332.28125 Z M 0.777344 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "46aee142d8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.277344 0.734375 L 34.542969 0.734375 C 40.511719 0.734375 46.234375 3.105469 50.453125 7.324219 C 54.675781 11.542969 57.042969 17.265625 57.042969 23.234375 L 57.042969 309.765625 C 57.042969 315.734375 54.675781 321.457031 50.453125 325.675781 C 46.234375 329.894531 40.511719 332.265625 34.542969 332.265625 L 23.277344 332.265625 C 17.308594 332.265625 11.585938 329.894531 7.367188 325.675781 C 3.148438 321.457031 0.777344 315.734375 0.777344 309.765625 L 0.777344 23.234375 C 0.777344 17.265625 3.148438 11.542969 7.367188 7.324219 C 11.585938 3.105469 17.308594 0.734375 23.277344 0.734375 Z M 23.277344 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e684be18b4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 58,
    y: 0,
    height: 333
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ccf7fbd611"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.117188 21.734375 L 571 21.734375 L 571 266.636719 L 116.117188 266.636719 Z M 116.117188 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8ebcaab5ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 138.617188 21.734375 L 548.03125 21.734375 C 554 21.734375 559.722656 24.105469 563.941406 28.324219 C 568.160156 32.542969 570.53125 38.265625 570.53125 44.234375 L 570.53125 244.136719 C 570.53125 250.105469 568.160156 255.828125 563.941406 260.046875 C 559.722656 264.265625 554 266.636719 548.03125 266.636719 L 138.617188 266.636719 C 132.648438 266.636719 126.925781 264.265625 122.707031 260.046875 C 118.488281 255.828125 116.117188 250.105469 116.117188 244.136719 L 116.117188 44.234375 C 116.117188 38.265625 118.488281 32.542969 122.707031 28.324219 C 126.925781 24.105469 132.648438 21.734375 138.617188 21.734375 Z M 138.617188 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "849f8ed785"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.117188 0.734375 L 454.71875 0.734375 L 454.71875 245.636719 L 0.117188 245.636719 Z M 0.117188 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7c46dccef3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.617188 0.734375 L 432.03125 0.734375 C 438 0.734375 443.722656 3.105469 447.941406 7.324219 C 452.160156 11.542969 454.53125 17.265625 454.53125 23.234375 L 454.53125 223.136719 C 454.53125 229.105469 452.160156 234.828125 447.941406 239.046875 C 443.722656 243.265625 438 245.636719 432.03125 245.636719 L 22.617188 245.636719 C 16.648438 245.636719 10.925781 243.265625 6.707031 239.046875 C 2.488281 234.828125 0.117188 229.105469 0.117188 223.136719 L 0.117188 23.234375 C 0.117188 17.265625 2.488281 11.542969 6.707031 7.324219 C 10.925781 3.105469 16.648438 0.734375 22.617188 0.734375 Z M 22.617188 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a44e02e53d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 455,
    y: 0,
    height: 246
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#52216b4b99)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb42b84c97)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 115, 297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#93c0675de1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b26680e936)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6fb0cdec21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.734375 0 L 455.054688 0 L 455.054688 56.265625 L 0.734375 56.265625 Z M 0.734375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ff49f0edf4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#72204f70f1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 29, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e684be18b4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3d94259f89)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#46aee142d8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.777344 0.734375 L 57.042969 0.734375 L 57.042969 332.1875 L 0.777344 332.1875 Z M 0.777344 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ccf7fbd611)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8ebcaab5ca)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 116, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a44e02e53d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#849f8ed785)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7c46dccef3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.117188 0.734375 L 454.527344 0.734375 L 454.527344 245.636719 L 0.117188 245.636719 Z M 0.117188 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntlogyWsGridIcon3);
export default __webpack_public_path__ + "static/media/antlogyWSGridIcon3.a0e48e66e99aa1328c350bcf8eed3bc7.svg";
export { ForwardRef as ReactComponent };